import { select } from '@inquirer/prompts';

import { log } from '../../utils/logging.js';
import {
  PROJECT_TYPES,
  type ProjectType,
  projectTypeSchema,
} from '../../utils/manifest.js';
import type { TemplateConfig } from '../../utils/template.js';
import { hasProp } from '../../utils/validation.js';

import type { ReadResult } from './types.js';

interface Props {
  manifest: ReadResult;
  templateConfig: TemplateConfig;
}

export const getProjectType = async ({
  manifest,
  templateConfig,
}: Props): Promise<ProjectType> => {
  const projectType = projectTypeSchema.safeParse(
    hasProp(manifest.packageJson.skuba, 'type')
      ? manifest.packageJson.skuba.type
      : null,
  );

  if (projectType.success) {
    return projectType.data;
  }

  if (templateConfig.type !== undefined) {
    return templateConfig.type;
  }

  const initial: ProjectType =
    manifest.packageJson.devDependencies?.['@seek/seek-module-toolkit'] ||
    manifest.packageJson.files
      ? 'package'
      : 'application';

  log.newline();

  return select({
    message: 'Project type:',
    choices: PROJECT_TYPES.map((type) => ({ name: type, value: type })),
    default: initial,
  });
};
